import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./lib/reportWebVitals";
import "./styles/index.css";
import "./styles/fonts.css";

const container = document.getElementById("root");

// Previously this was cast with `as HTMLElement`, which turned a missing root
// into an obscure null-deref inside React instead of a clear error.
if (!container) {
  throw new Error('Unable to mount: no element with id "root" in index.html');
}

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Pass a handler (e.g. `reportWebVitals(console.log)`) to start reporting.
reportWebVitals();
